import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Edit2 } from "react-feather";

const AllCoupon = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editData, setEditData] = useState(null);

  // Fetch all coupons
  const fetchCoupons = async () => {
    try {
      console.log("📥 Fetching all coupons...");
      const response = await axios.get(`${baseurl}getAllCoupons`);

      if (response.data.success) {
        console.log("✅ Coupons fetched:", response.data.data);
        setCoupons(response.data.data);
      } else {
        Swal.fire("Error", "Failed to fetch coupons.", "error");
      }
    } catch (error) {
      console.error("❌ Error fetching coupons:", error);
      Swal.fire("Error", "Something went wrong while fetching coupons.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  // Handle Delete Coupon
  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteCoupon/${id}`);
        Swal.fire("Deleted!", "Coupon has been deleted.", "success");
        fetchCoupons(); // Refresh table after delete
      } catch (error) {
        console.error("❌ Error deleting coupon:", error);
        Swal.fire("Error", "Failed to delete coupon.", "error");
      }
    }
  };

  // Handle Edit Coupon
  const handleEdit = (coupon) => {
    setEditData(coupon);
  };

  // Handle Edit Form Submission
  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      await axios.put(`${baseurl}updateCoupon/${editData.id}`, editData);
      Swal.fire("Updated!", "Coupon has been updated.", "success");
      setEditData(null);
      fetchCoupons(); // Refresh table after update
    } catch (error) {
      console.error("❌ Error updating coupon:", error);
      Swal.fire("Error", "Failed to update coupon.", "error");
    }
  };

  // Handle Edit Input Change
  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "Coupon Code",
      selector: (row) => row.coupon_code,
      sortable: true,
    },
    {
      name: "Discount Amount",
      selector: (row) => `₹${row.discount_amount}`,
      sortable: true,
    },
    {
      name: "Min Order Amount",
      selector: (row) => `₹${row.min_order_amount}`,
      sortable: true,
    },
    {
      name: "Valid From",
      selector: (row) => new Date(row.valid_from).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Valid To",
      selector: (row) => new Date(row.valid_to).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Usage Limit",
      selector: (row) => row.usage_limit,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btnedit me-2"
            onClick={() => handleEdit(row)}
          >
            ✏️
          </button>
          <button
            className="btn btndelete"
            onClick={() => handleDelete(row.id)}
          >
            🗑
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">


        <div className="text-start mb-2 catnav">
            <Link  className="nacs catitm me-2 activecat" data-discover="true" 
            to="/admin/add-coupon">Add Coupon</Link>
            
           </div>


          <div className="crd1 mb-3">
            <DataTable
            //   title="Coupon List"
              columns={columns}
              data={coupons}
              progressPending={loading}
              pagination
              highlightOnHover
              striped
            />
          </div>
        </div>
      </div>

      {/* Edit Coupon Modal */}
      {editData && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Coupon</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditData(null)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpdate}>
                  <div className="mb-3">
                    <label className="form-label">Coupon Code</label>
                    <input
                      type="text"
                      name="coupon_code"
                      className="form-control"
                      value={editData.coupon_code}
                      onChange={handleEditChange}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Discount Amount</label>
                    <input
                      type="number"
                      name="discount_amount"
                      className="form-control"
                      value={editData.discount_amount}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Min Order Amount</label>
                    <input
                      type="number"
                      name="min_order_amount"
                      className="form-control"
                      value={editData.min_order_amount}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Usage Limit</label>
                    <input
                      type="number"
                      name="usage_limit"
                      className="form-control"
                      value={editData.usage_limit}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">
                      Update Coupon
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setEditData(null)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllCoupon;
